import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { LanguageProvider } from "@/i18n";
import { AuthProvider, RequireAuth } from "@/lib/auth";
import { ThemeProvider } from "@/studio/lib/theme";

import StudioSite from "@/studio/StudioSite";
import StudioProject from "@/studio/StudioProject";
import StudioServicesPage from "@/studio/ServicesPage";
import ContactPage from "@/pages/ContactPage";
import NotesIndex from "@/pages/NotesIndex";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import DashboardPage from "@/pages/admin/DashboardPage";
import ProjectsListPage from "@/pages/admin/ProjectsListPage";
import ProjectEditPage from "@/pages/admin/ProjectEditPage";
import ServicesPage from "@/pages/admin/ServicesPage";
import TestimonialsPage from "@/pages/admin/TestimonialsPage";
import SettingsPage from "@/pages/admin/SettingsPage";
import MessagesPage from "@/pages/admin/MessagesPage";
import MediaPage from "@/pages/admin/MediaPage";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <ThemeProvider>
          <BrowserRouter>
          <Routes>
            {/* Public */}
            <Route path="/" element={<StudioSite />} />
            <Route path="/services" element={<StudioServicesPage />} />
            <Route path="/work/:slug" element={<StudioProject />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/notes" element={<NotesIndex />} />

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <RequireAuth>
                  <AdminLayout />
                </RequireAuth>
              }
            >
              <Route index element={<DashboardPage />} />
              <Route path="portfolio" element={<ProjectsListPage />} />
              <Route path="portfolio/new" element={<ProjectEditPage />} />
              <Route path="portfolio/:id" element={<ProjectEditPage />} />
              <Route path="services" element={<ServicesPage />} />
              <Route path="testimonials" element={<TestimonialsPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="messages" element={<MessagesPage />} />
              <Route path="media" element={<MediaPage />} />
            </Route>

            {/* 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>

          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#0a0a0c",
                color: "#fff",
                border: "1px solid rgba(255,255,255,0.08)",
              },
            }}
          />
        </BrowserRouter>
        </ThemeProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
